module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG0004-7ecf31c60cfd6ec5d429a85d20f3f1ae.png";